import { Injectable } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class SharedValidationService {
  config: any = {};
  stateCodes: string[] = ['AD', 'AR', 'AS', 'BR', 'CG', 'DL', 'GA', 'GJ', 'HR', 'HP', 'JK', 'JH', 'KA', 'KL', 'LD', 'MP', 'MH', 'MN', 'ML', 'MZ', 'NL', 'OD', 'PY', 'PB', 'RJ', 'SK', 'TN', 'TS', 'TR', 'UP', 'UK', 'WB', 'AN', 'CH', 'DNHDD', 'LA', 'OT'];
  constructor() {}

  public getValidatorErrorMessage(
    validatorName: string,
    validatorValue?: any,
    propertyName?: string
  ) {
    const config: any = {
      required: `${propertyName} is required`,
      minlength: `Minimum length should be ${validatorValue.requiredLength} characters`,
      maxlength: `Maximum length should be ${validatorValue.requiredLength} characters`,
      min: `Minimum value should be ${validatorValue.min}`,
      max: `Maximum value should be ${validatorValue.min}`,
      passwordMismatch: "Password doesn't match",
      invalidEmailAddress: "Please enter valid email address",
      invalidWebsiteUrl: "Please enter valid website url",
      invalidCityPinCode: "Please enter valid pin code",
      NOT_SELECTED: "Please select value from dropdown",
      phone_number_already_exist: "User already exists with this phone number",
      validatePan: "Pan format is not correct",
      validateDL: "Driving License format is not correct",
      checkFileType: "File Format is not correct",
      validateAdhar: "Adhar Card Format is not correct",
      validateFssai: "FSSAI Format is not correct",
      validateGst: "GST Format is not correct",
      company_name_already_exist: "Company Name Is Not Unique",
      validateRC: "Please provide valid Vehicle Number",
      invalidPassword: "Minimum eight characters, at least one letter, one number and one special character"
    };

    return config[validatorName];
  }

  matchPassword(control:AbstractControl): ValidationErrors | null{
      const passwordControl = control.get('password');
      const confirmPasswordControl = control.get('confirm_password');
      if (!passwordControl || !confirmPasswordControl) {
        return null;
      }

      if (confirmPasswordControl.errors && !confirmPasswordControl.errors['passwordMismatch']) {
        return null;
      }

      if (passwordControl.value !== confirmPasswordControl.value) {
        confirmPasswordControl.setErrors({ passwordMismatch: true });
      } else {
        confirmPasswordControl.setErrors(null);
      }

      return null;
  }

  emailValidator(control: FormControl) {
    // RFC 2822 compliant regex
    return new Promise(resolve => {
      if (control.value.match(
        /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/
      )) {
        resolve(null);
      } else {
        resolve({ invalidEmailAddress: true });
      }
    });
  }

  ifscValidator(control: FormControl) {
    return new Promise(resolve => {
      if (control.value.match(
       /^[A-Z]{4}0[A-Z0-9]{6}$/
      )) {
        resolve(null);
      } else {
        resolve({ invalidIfsc: true });
      }
    });
  }

  websiteValidator(control: FormControl) {
    // console.debug("website control",control.value)
    if (control.value != "") {
      return this.validateWebsite(control.value) ? null : { 'invalidWebsiteUrl': true };
    }
    return null
  }

  validateWebsite(website: string) {
    const re = /^((ftp|http|https):\/\/)?(www.)?[a-zA-Z0-9_-]+(\.[a-zA-Z]{2,3})+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/
    // const re = /^((ftp|http|https):\/\/)?(www.)(?!.(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]{2,3})+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/
    // const re = /^(?:(?:http(s))?:\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i
    // // this.restApiService.debug("website", re.test(String(website).toLowerCase()));
    return re.test(String(website).toLowerCase());
  }

  //  Pin code regex for India and Nepal
  pinCodeValidator(control: FormControl) {
    return new Promise(resolve => {
      if (control.value.match(
        /^[1-9]{1}[0-9]{2}\s{0,1}[0-9]{3}$/
      ) || control.value.match(
        /^[1-9]{1}[0-9]{2}\s{0,1}[0-9]{2}$/
      )) {
        resolve(null)
      } else {
        resolve(
          { invalidCityPinCode: true }
        )
      }
    })
  }

  rcNumberValidator(control: FormControl) {
    return new Promise(resolve => {
      console.debug("control vehicle", typeof (control?.value))
      if (control?.value != null) {
        if (typeof (control?.value) == 'object') {
          resolve(null);
        }
        else if (control.value.match(
          /[A-Za-z][A-Za-z][0-9][0-9][A-Za-z ][A-Za-z][0-9][0-9][0-9][0-9]$/igm
        ) || control.value.match(
          /[A-Za-z][A-Za-z][0-9][0-9][A-Za-z ][0-9][0-9][0-9][0-9]$/igm
        )) {
          // console.debug("regex format passed",this.stateCodes.includes(control.value.slice(0,2).toUpperCase()))
          if (this.stateCodes.includes(control.value.slice(0, 2).toUpperCase())) {
            // console.debug("regex format state code",control.value.slice(0,2).toUpperCase())
            resolve(null)
          } else {
            resolve(
              { validateRC: true }
            )
          }
        } else {
          resolve(
            { validateRC: true }
          )
        }
      }
    })
  }

  passwordValidator(control: FormControl) {
    //
    return new Promise(resolve => {
      if (control.value.match(
        /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/
      )) {
        resolve(null);
      } else {
        resolve({ invalidPassword: true });
      }
    });
  }

nameValidator(control: FormControl){
  return new Promise((resolve) => {
    const namePattern = /^[a-zA-Z\-'.\s]+$/;
    if (!control.value.trim()) {
        resolve({ emptyName: true });
    }
    else if (!namePattern.test(control.value)) {
        resolve({ invalidCharacters: true });
    } else {
        resolve(null);
    }
});
}

tripNameValidator(control: FormControl){
  return new Promise((resolve) => {
    const namePattern = /^[a-zA-Z0-9 _-]*$/;
    if (!control.value.trim()) {
        resolve({ emptyName: true });
    }
    else if (!namePattern.test(control.value)) {
        resolve({ invalidCharacters: true });
    } else {
        resolve(null);
    }
});
}
accountNumberValidator(control: FormControl) {
  const accountRegex = /^\d{6,18}$/;
  return new Promise(resolve => {
    if (control.value.match(accountRegex)) {
      resolve(null);
    } else {
      resolve({ invalidAccountNumber: true });
    }
  });
}

categoryNameValidator(control: FormControl) {
  const categoryRegex = /^[a-zA-Z0-9\s]{1,20}$/;
  return new Promise(resolve => {
    if (control.value.match(categoryRegex)) {
      resolve(null);
    } else {
      resolve({ invalidCategoryName: true });
    }
  });
}
 phoneNumberValidator(control: FormControl) {
    // Define a regular expression pattern for a typical US phone number (10 digits)
    const phoneRegex = /^\d{10}$/;
  
    // Return a Promise that resolves with either null (valid) or an object with an error (invalid).
    return new Promise(resolve => {
      // Check if the control's value matches the specified regex pattern.
      if (control.value.match(phoneRegex)) {
        // If the phone number is valid, resolve with null.
        resolve(null);
      } else {
        // If the phone number is invalid, resolve with an object containing an 'invalidPhoneNumber' property.
        resolve({ invalidPhoneNumber: true });
      }
    });
  }
}
